'object' == typeof Countries &&
  (Countries.updateProvinceLabel = function (e, t) {
    if ('string' == typeof e && Countries[e] && Countries[e].provinces) {
      if (
        'object' != typeof t &&
        ((t = document.getElementById('address_province_label')), null === t)
      )
        return;
      t.innerHTML = Countries[e].label;
      var r = jQuery(t).parent();
      r.find('select');
      r.find('.custom-style-select-box-inner').html(Countries[e].provinces[0]);
    }
  }),
  'undefined' == typeof Shopify.Cart && (Shopify.Cart = {}),
  (Shopify.Cart.ShippingCalculator = (function () {
    var _config = {
        submitButton: 'Calculate shipping',
        submitButtonDisabled: 'Calculating...',
        templateId: 'shipping-calculator-response-template',
        wrapperId: 'wrapper-response',
        customerIsLoggedIn: !1,
        moneyFormat: '${{amount}}',
      },
      _render = function (e) {
        var t = jQuery('#' + _config.templateId),
          r = jQuery('#' + _config.wrapperId);
        if (t.length && r.length) {
          var templateSettings = {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g,
          };
          var n = Handlebars.compile(jQuery.trim(t.text())),
            a = n(e);
          if (
            (jQuery(a).appendTo(r),
            'undefined' != typeof Currency && 'function' == typeof Currency.convertAll)
          ) {
            var i = '';
            jQuery('[name=currencies]').size()
              ? (i = jQuery('[name=currencies]').val())
              : jQuery('#currencies span.selected').size() &&
                (i = jQuery('#currencies span.selected').attr('data-currency')),
              '' !== i &&
                Currency.convertAll(
                  shopCurrency,
                  i,
                  '#wrapper-response span.money, #estimated-shipping span.money',
                );
          }
        }
      },
      _enableButtons = function () {
        jQuery('.get-rates')
          .removeAttr('disabled')
          .removeClass('disabled')
          .val(_config.submitButton);
      },
      _disableButtons = function () {
        jQuery('.get-rates').val(_config.submitButtonDisabled);
      },
      _getCartShippingRatesForDestination = function (e) {
        var params = new URLSearchParams();
        Object.keys(e).forEach(function (key) {
          params.append('shipping_address[' + key + ']', e[key]);
        });

        fetch('/cart/prepare_shipping_rates', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: params.toString(),
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw { responseText: data, status: response.status };
              });
            }
            _pollForCartShippingRatesForDestination(e);
          })
          .catch(function (error) {
            _onError(error);
          });
      },
      _pollForCartShippingRatesForDestination = function (e) {
        var poll = function () {
          fetch('/cart/async_shipping_rates', {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          })
            .then(function (response) {
              if (response.status === 200) {
                return response.json().then(function (data) {
                  _onCartShippingRatesUpdate(data.shipping_rates, e);
                });
              } else {
                setTimeout(poll, 500);
              }
            })
            .catch(function (error) {
              _onError(error);
            });
        };
        poll();
      },
      _fullMessagesFromErrors = function (e) {
        var t = [];
        return (
          jQuery.each(e, function (e, r) {
            jQuery.each(r, function (r, n) {
              t.push(e + ',' + ' ' + n);
            });
          }),
          t
        );
      },
      _onError = function (XMLHttpRequest, textStatus) {
        jQuery('#shipping-calculator-response-template').hide(),
          jQuery('#shipping-calculator-response-template').empty(),
          _enableButtons();
        var feedback = '',
          data = eval('(' + XMLHttpRequest.responseText + ')');
        (feedback = data.message
          ? data.message + '(' + data.status + '): ' + data.description
          : 'Error : ' + _fullMessagesFromErrors(data).join('; ') + '.'),
          'Error : country is not supported.' === feedback &&
            (feedback = 'We do not ship to this destination.'),
          console.log(feedback);
        jQuery('#shipping-calculator-result_heading').hide();
        jQuery('#shipping-calculator-response-template').show();
        jQuery('#shipping-calculator-response-template').append(
          "<div class='result_container'><p>" + feedback + '</p></div>',
        );
      },
      _onCartShippingRatesUpdate = function (e, t) {
        _enableButtons();
        var r = '';
        jQuery('#shipping-calculator-response-template').empty();
        for (n = 0; n < e.length; n++) {
          if (e[n].delivery_date == null) {
            var delivery_date =
              'Processing time for imprinting typically adds 2 to 6 business days depending on the queue, and adds 1-3 business days for iPad folder builds.';
          } else {
            var rawDate = new Date(e[n].delivery_date);
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            rawDate.setHours(0, 0, 0, 0);
            if (rawDate <= today) {
              rawDate.setDate(rawDate.getDate() + 3);
            }
            var delivery_date = rawDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
          }
          let newElement = $('<div>');
          newElement.attr('id', 'result-' + n);
          newElement.attr('class', 'result_container');
          newElement.append('<div><b>' + e[n].name + '</b></div>');
          newElement.append(
            '<div><b>' +
              _formatRate(e[n].price) +
              '</b>' +
              ' - Delivery Estimate: ' +
              delivery_date +
              '</div>',
          );
          jQuery('#shipping-calculator-response-template').append(newElement);
        }
        jQuery('#shipping-calculator-result_heading').show();
        jQuery('#shipping-calculator-response-template').show();
      },
      _formatRate = function (e) {
        function t(e, t) {
          return 'undefined' == typeof e ? t : e;
        }
        function r(e, r, n, a) {
          if (((r = t(r, 2)), (n = t(n, ',')), (a = t(a, '.')), isNaN(e) || null == e)) return 0;
          e = (e / 100).toFixed(r);
          var i = e.split('.'),
            o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + n),
            s = i[1] ? a + i[1] : '';
          return o + s;
        }
        if ('function' == typeof Shopify.formatMoney)
          return Shopify.formatMoney(e, _config.moneyFormat);
        'string' == typeof e && (e = e.replace('.', ''));
        var n = '',
          a = /\{\{\s*(\w+)\s*\}\}/,
          i = _config.moneyFormat;
        switch (i.match(a)[1]) {
          case 'amount':
            n = r(e, 2);
            break;
          case 'amount_no_decimals':
            n = r(e, 0);
            break;
          case 'amount_with_comma_separator':
            n = r(e, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            n = r(e, 0, '.', ',');
        }
        return i.replace(a, n);
      };
    return (
      (_init = function () {
        new Shopify.CountryProvinceSelector('address_country', 'address_province', {
          hideElement: 'address_province_container',
        });
        var e = jQuery('#address_country'),
          t = jQuery('#address_province_label').get(0);
        'undefined' != typeof Countries &&
          (Countries.updateProvinceLabel(e.val(), t),
          e.change(function () {
            Countries.updateProvinceLabel(e.val(), t);
          })),
          jQuery('.get-rates').click(function () {
            _disableButtons(),
              jQuery('#' + _config.wrapperId)
                .empty()
                .hide();
            var e = {};
            (e.zip = jQuery('#address_zip').val() || ''),
              (e.country = jQuery('#address_country').val() || ''),
              (e.province = jQuery('#address_province').val() || ''),
              _getCartShippingRatesForDestination(e);
            if (jQuery('#address_country').val() != 'United States') {
              jQuery('#duty-disclaimer').show();
            } else {
              jQuery('#duty-disclaimer').hide();
            }
          });
      }),
      {
        show: function (e) {
          (e = e || {}),
            jQuery.extend(_config, e),
            jQuery(function () {
              _init();
            });
        },
        getConfig: function () {
          return _config;
        },
        formatRate: function (e) {
          return _formatRate(e);
        },
      }
    );
  })());

Shopify.Cart.ShippingCalculator.show({
  submitButton: theme.strings.shippingCalcSubmitButton,
  submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
  customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
  moneyFormat: theme.strings.shippingCalcMoneyFormat,
});
